import type { Route } from "./+types/learnings";
import Page from "../pages/Learnings";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.articles() }; }
export const meta = () => pageMeta({ title: "Learnings | Gazar", description: "Everything I've learned about frontend, backend, system design, and engineering leadership.", path: "/learnings", image: OG_IMAGE.learnings });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
